module.exports = __webpack_public_path__ + "img/Weapon_214.7582199b.png";